import { render, staticRenderFns } from "./LessonNavigationSection.vue?vue&type=template&id=5700b63f"
import script from "./LessonNavigationSection.vue?vue&type=script&lang=js"
export * from "./LessonNavigationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports